<template>
    <div class="col-12">
        <div class="form-group row m-b-sm">
            <div :class="{'has-error': hasError('recipient.name')}" class="col-md-4">
                <label>{{ __('company_name_or_first_name_and_second_name') }}{{
                        isRequiredDesignation('recipient_name')
                    }}</label>
                <select2
                    :disabled="disabled"
                    :options="recipientNameOptions"
                    :settings="countrySettings"
                    :value="recipient.id"
                    @change="setRecipient(parseInt($event))"
                />
                <InputErrors :errors="getErrors('recipient.name')"/>
            </div>

            <div :class="{'has-error': hasError('recipient.country_id')}" class="col-md-2">
                <label>{{ __('country') }}{{
                        isRequiredDesignation('recipient_country')
                    }}</label>
                <select2
                    :disabled="true"
                    :options="countriesOptions"
                    :settings="countrySettings"
                    :value="recipient.country_id"
                    @change="tryDefaultIdNumberType"
                    @input="emitInput('country_id', parseInt($event))"
                />

                <InputErrors :errors="getErrors('recipient.country_id')"/>
            </div>

            <div :class="{'has-error': hasError('recipient.id_type')}" class="col-md-2">
                <label>{{ __('identification_number_id') }}{{
                        isRequiredDesignation('recipient_id_number_type')
                    }}</label>
                <select2
                    :disabled="true"
                    :options="idNumberTypesOptions"
                    :settings="idNumbersSettings"
                    :value="recipient.id_type"
                    @input="idNumberTypeChanged"
                />

                <InputErrors :errors="getErrors('recipient.id_type')"/>
            </div>

            <div :class="{'has-error': hasError('recipient.id_number')}" class="col">
                <InputWrapper
                    :disabled="true"
                    :errors="getErrors('recipient.id_number')"
                    :label="__('identification_number') + isRequiredDesignation('recipient_id_number')"
                    :value="recipient.id_number"
                    classNames="form-control"
                    type="text"
                    @input="emitInput('id_number', $event)"
                />
            </div>
            <div class="col-md-auto " v-if="type.type_name == 'invoicing_pl_VAT' || type.type_name == 'invoicing_pl_margin'">
                <div class="input-group m-l-xs m-r-xs m-b-xs m-t-sm"><label class=""><input type="checkbox"
                                                                                            :disabled="true"
                                                                                                           readonly="readonly"
                                                                                                            @change="handleViesChange()"
                                                                                                           class="mt-3 protect-unsaved-changes disabled-checkbox&quot;"
                                                                                                           v-model="recipient.vies">
                    VIES </label></div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <div class="row m-b-sm">
                    <div :class="{'has-error': hasError('recipient.address')}" class="col-md-12 m-b-sm">
                        <InputWrapper
                            :disabled="true"
                            :errors="getErrors('recipient.address')"
                            :label="__('full_address') "
                            :value="recipient.address"
                            classNames="form-control"
                            type="text"
                            @input="emitInput('address', $event)"
                        />
                    </div>
                    <div :class="{'has-error': hasError('recipient.address_2')}" class="col-md-12 m-b-sm">
                        <InputWrapper
                            :disabled="true"
                            :errors="getErrors('recipient.address_2')"
                            :value="recipient.address_2"
                            classNames="form-control"
                            type="text"
                            @input="emitInput('address_2', $event)"
                        />
                    </div>
                    <div :class="{'has-error': hasError('recipient.zip')}" class="col-md-6 m-b-sm">
                        <InputWrapper
                            :disabled="true"
                            :errors="getErrors('recipient.zip')"
                            :label="__('zip') "
                            :value="recipient.zip"
                            classNames="form-control"
                            type="text"
                            @input="emitInput('zip', $event)"
                        />
                    </div>
                    <div :class="{'has-error': hasError('recipient.city')}" class="col-md-6 m-b-sm">
                        <InputWrapper
                            :disabled="true"
                            :errors="getErrors('recipient.city')"
                            :label="__('city') "
                            :value="recipient.city"
                            classNames="form-control"
                            type="text"
                            @input="emitInput('city', $event)"
                        />
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div :class="{'has-error': hasError('recipient.remarks')}" class="form-group">
                    <label>{{ __('additional_information_invisible_in_document') }}</label>
                    <textarea
                        :disabled="true"
                        :value="recipient.remarks"
                        class="form-control"
                        style="height:126px;"
                        @input="emitInput('remarks', $event.target.value)"
                    ></textarea>

                    <InputErrors :errors="getErrors('recipient.remarks')"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import inputEmit from "../../mixins/inputEmit";
import InputWrapper from "../form/InputWrapper";
import hasErrors from "../../mixins/hasErrors";
import InputErrors from "../form/InputErrors";
import hasRequiredFields from "../../mixins/hasRequiredFields";

export default {
    name: "RecipientForm",
    components: {InputErrors, InputWrapper},
    mixins: [inputEmit, hasErrors, hasRequiredFields],
    props: {
        recipient: {
            type: Object,
            required: true,
        },
        countries: {
            type: Array,
            default: () => [],
        },
        idNumbers: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        type: {
            type: Object,
            required: true,
        },
        selectedContractor:{
            type: Object,
            default:{}
        }
    },
    computed: {
        recipientNameOptions() {
            let options = [{ id: 0, text: '---' }];

            if (this.selectedContractor?.recipients?.length) {
                options = options.concat(
                    this.selectedContractor.recipients.map(item => ({
                        id: item.id,
                        text: item.name,
                    }))
                );
            }
            return options;
        },
        countriesOptions() {
            return this.countries.map((option) => ({text: option.localized_name, id: option.id}));
        },
        idNumberTypesOptions() {
            return this.idNumbers.filter(this.filterIdNumberTypes(this.recipient.country_id))
                .sort(this.sortIdNumberTypes)
                .map((option) => ({text: option.pattern_name, id: option.id}));
        },
        selectedIdNumberCantBeVies(){
            let idNumber = this.idNumbers.find(c => c.id === parseInt(this.recipient.id_type));
            if (idNumber !== undefined){
                if(idNumber.can_be_vies){
                    return false;
                }

            }
            return true;

        },
        idNumbersSettings() {
            return {
                templateResult: (option) => {
                    let idNumber = this.idNumbers.find(c => c.id === parseInt(option.id));

                    if (idNumber !== undefined && idNumber.isTrashed) return null;

                    return option.text;
                },
                width:'100%'
            };
        },
        countrySettings() {
            return {
                templateResult: (option) => {
                    let country = this.countries.find(c => c.id === parseInt(option.id));

                    if (country !== undefined && country.isTrashed) return null;

                    return option.text;
                },
                width:'100%'
            };
        },
    },
    methods: {
        getIdNumberType(typeId) {
            return this.idNumbers.find(id => id.id === typeId) || {};
        },
        async handleViesChange() {
            if (this.recipient.vies) {
                let response = await make_vies_simple_check({
                    'type': this.recipient.id_type,
                    'number': this.recipient.id_number
                })
                if (response.valid) {
                    handle_valid_response_vies_simple_check(response)
                } else {
                    handle_invalid_response_vies_simple_check(response)
                    this.recipient.vies = false;
                }
            }
        },
        idNumberTypeChanged(value) {
            const selectedId = parseInt(value);
            let selected = this.getIdNumberType(selectedId);
            this.recipient.vies = 0;
            if (selected.pattern_type === 'none') {
                this.emitInput('id_number', '');
            }

            this.emitInput('id_type', selectedId);
        },
        filterIdNumberTypes(countryId) {
            return (number) => {
                if (number.pattern_type === 'other' || number.pattern_type === 'none') return true;
                return number.country_id === countryId;
            };
        },
        sortIdNumberTypes(a, b) {
            a.weight = a.pattern_type === null ? 1 : (a.pattern_type == 'none' ? 3 : 2);
            b.weight = b.pattern_type === null ? 1 : (b.pattern_type == 'none' ? 3 : 2);

            if (a.weight === b.weight) {
                return b.pattern_name > a.pattern_name ? -1 : 1;
            }

            return a.weight > b.weight ? 1 : -1;
        },
        tryDefaultIdNumberType(value) {
            const availableOptions = this.idNumbers.filter(this.filterIdNumberTypes(parseInt(value))).sort(this.sortIdNumberTypes);
            this.recipient.vies = 0;
            if (availableOptions.length > 0){
                this.emitInput('id_type', availableOptions[0].id);

            }
        },
        setRecipient(id){
            const _this = this;
            let recipient = this.selectedContractor?.recipients?.find(function ($item){
                return $item.id == id
            })
            if(recipient){
                this.$emit('assignRecipient', recipient)
            }else{
                this.$emit('resetRecipient')
            }
        }
    },
};
</script>
